import React, { forwardRef, ReactElement } from 'react'
import { Icon, IconBase, IconWeight } from '@phosphor-icons/react'

const getWeights = (color?: string) => {
    const regular: ReactElement = (
        <svg width="256" height="256" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2907_20730)">
                <path
                    d="M75.5823 203.295L42.4411 231.108C41.2453 232.102 39.7934 232.734 38.2538 232.933C36.7143 233.131 35.1502 232.888 33.7431 232.23C32.336 231.572 31.1435 230.527 30.304 229.216C29.4644 227.906 29.0123 226.383 29 224.824V61.241C29 59.0553 29.8648 56.9592 31.4042 55.4137C32.9435 53.8682 35.0313 53 37.2083 53H217.792C219.969 53 222.056 53.8682 223.596 55.4137C225.135 56.9592 226 59.0553 226 61.241V193.097C226 195.282 225.135 197.378 223.596 198.924C222.056 200.469 219.969 201.338 217.792 201.338H80.8151C78.8933 201.338 77.0359 202.033 75.5823 203.295V203.295Z"
                    stroke={color}
                    strokeWidth="16"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M93 128H163" stroke={color} strokeWidth="16" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M128 93V163" stroke={color} strokeWidth="16" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_2907_20730">
                    <rect width="256" height="256" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
    const fill: ReactElement = (
        <svg width="256" height="256" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37.6696 44H217.359C221.692 44 225.847 45.721 228.91 48.7845C231.974 51.848 233.695 56.003 233.695 60.3354V191.019C233.695 195.351 231.974 199.506 228.91 202.57C225.847 205.633 221.692 207.354 217.359 207.354L80.5501 207.763L48.1855 235.022C45.8035 237.005 42.9068 238.268 39.8335 238.666C36.7603 239.064 33.6373 238.579 30.8291 237.269C27.9758 235.995 25.557 233.915 23.87 231.285C22.1831 228.655 21.3017 225.589 21.3342 222.465V60.3354C21.3342 56.003 23.0552 51.848 26.1187 48.7845C29.1822 45.721 33.3372 44 37.6696 44ZM136 93C136 88.5817 132.418 85 128 85C123.582 85 120 88.5817 120 93V120H93C88.5817 120 85 123.582 85 128C85 132.418 88.5817 136 93 136H120V163C120 167.418 123.582 171 128 171C132.418 171 136 167.418 136 163V136H163C167.418 136 171 132.418 171 128C171 123.582 167.418 120 163 120H136V93Z"
                fill={color}
            />
        </svg>
    )
    return new Map<IconWeight, ReactElement>([
        ['regular', regular],
        ['fill', fill],
    ])
}

/**
 * Phosphor custom icon based on https://github.com/phosphor-icons/react#custom-icons
 */
const CommentPlus: Icon = forwardRef((props, ref) => {
    return <IconBase ref={ref} {...props} weights={getWeights(props.color)} fill="None" />
})

CommentPlus.displayName = 'CommentPlus'

export default CommentPlus
